import React, { useEffect } from 'react'
import { MetricTimeUnit } from 'enums'
import { createMetric } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import MeasureType from 'enums/MeasureType'

const createSearch = (detailSetting: InsightContentSettingType) => {
  const { filter, precision, topicId, selectionFilter } = detailSetting

  const timeUnits = [MetricTimeUnit.ALL, getSparklineMetricTimeUnit(filter?.publishedDate)]
  const option = {
    smoothing: false
  }

  return createMetric(
    -1,
    '',
    precision!,
    [topicId!],
    selectionFilter,
    getMetricSeries(MeasureType.OVERALL_SURVEY_SCORES_AVERAGE),
    timeUnits,
    option
  )
}

const RunSearchEffect = ({
  detailSetting,
  children
}: {
  detailSetting: InsightContentSettingType
  children: React.ReactNode
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.OVERALL_SURVEY_SCORES_AVERAGE,
        searches: [searches],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
